namespace TabAurous.Finance {
    export interface JournalForm {
        VoucherTypeId: Serenity.IntegerEditor;
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        RefNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        EnteredBy: Serenity.StringEditor;
        TaxLedgerId: Serenity.IntegerEditor;
        CurrencyId: Serenity.LookupEditor;
        Details: JournalDetailEditor;
        UserId: Serenity.DecimalEditor;
        TotalAmount: Serenity.DecimalEditor;
        Narration: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class JournalForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.Journal';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JournalForm.init)  {
                JournalForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;
                var w4 = JournalDetailEditor;
                var w5 = s.DecimalEditor;

                Q.initFormType(JournalForm, [
                    'VoucherTypeId', w0,
                    'TransDate', w1,
                    'VoucherNo', w2,
                    'LedgerId', w3,
                    'RefNo', w2,
                    'RefDate', w1,
                    'EnteredBy', w2,
                    'TaxLedgerId', w0,
                    'CurrencyId', w3,
                    'Details', w4,
                    'UserId', w5,
                    'TotalAmount', w5,
                    'Narration', w2,
                    'CompanyId', w0,
                    'FinancialYearId', w0
                ]);
            }
        }
    }
}
